export default "__VITE_ASSET__D2SO4GN$__"